import { EmployeeRank } from '@components/reports/employees/EmployeeRank';
import { BaseReportPage } from './bases/BaseReportPage';

export const Employees = ({
    setDateRange,
    dateRange,
}: {
    setDateRange: (range: { startDate: string; endDate: string }) => void;
    dateRange: { startDate: string; endDate: string };
}) => {
    return (
        <BaseReportPage title={'MO Insights Employees'} dateRange={dateRange} setDateRange={setDateRange}>
            <EmployeeRank dateRange={dateRange} />
        </BaseReportPage>
    );
};
